export default __webpack_public_path__ + "static/media/2324 spice rack side.b874347a.png";